import { useQuery } from "@tanstack/react-query"

import type { DeploymentSwitchesResponse } from "@/api/admin-api"

import { getDeploymentSwitches } from "@/api/admin-api"

// Effective deployment switches (spec R6). R6.2 makes the reported values
// boot-captured, so they cannot change while the process lives and polling would
// only re-fetch constants. `staleTime: Infinity` therefore serves the cache until
// an explicit refetch — a restarted stack being the one case that can produce a
// different answer.
export function useDeploymentSwitchesQuery() {
  return useQuery<DeploymentSwitchesResponse>({
    queryKey: ["admin", "deployment-switches"],
    queryFn: getDeploymentSwitches,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
